// Pulls down sticky ads for higher visibility
// when the user has scrolled down on page
(function($) {

    function __sticky_log(m) {
        return window.console && window.console.log('[Sticky Ad] > ' + m);
    }

    // Default sticky ad config for Desktop
    var conf = {
        stickyEnabled: true,     // enable/disable sticky ad.
        thresholdHeight: 109,    // max ad height to allow sticky
        stickyDuration: 5000,    // duration for which sticky sticks
        waitForAdInterval: 1500, // wait for ad status to change to rendered
        waitForAdRetries: 150    // number of retries to check ad rendered state
    };

    var fixedTopPos = -30;
    var adSpot = 'leaderboard_flex';
    var placeholderStyle = "margin-top: 30px; margin-bottom: 15px;";

    // Mobileweb overrides
    if ( window.location.hostname.indexOf("m.") === 0 ) {
        fixedTopPos = -5;
        adSpot = 'mobileweb_top';
        placeholderStyle = "margin-bottom: 15px;";
    }

    (function(){
        __sticky_log('configuration: ' + JSON.stringify(conf));

        if (!conf.stickyEnabled) {
            return;
        }

        var fadeAd = function($ad) {
            var height = $ad.height();
            var $placeholderAd = $('<div />').attr('style', placeholderStyle + "; height: " + height + "px;");
            $ad.before($placeholderAd);
            $ad.addClass('fixed').css('height', height).css('top', - height - 55).addClass('primer');
            setTimeout(function() {
                $ad.css('top', fixedTopPos);
                setTimeout(function() {
                    $ad.removeClass('primer').css('height', '');
                    setTimeout(function() {
                        $ad.css('top', - height - 55);
                        setTimeout(function() {
                            $ad.removeClass('fixed');
                            $placeholderAd.remove();
                        }, 500);
                    }, conf.stickyDuration);
                }, 500);
            }, 100);
        };

        var retries = conf.waitForAdRetries;
        var waitingForAd = setInterval(function() {
            if (!retries) {
                clearInterval(waitingForAd);
            }
            if ( window.jQuery && $('.ad-' + adSpot + '.ad-rendered').length > 0 ) {
                var $ad = $('.ad-' + adSpot + '.ad-rendered').closest(".sticky-advertisement").eq(0);
                if ($ad.innerHeight() > 0 && $ad.innerHeight() < conf.thresholdHeight) {
                    if ($ad.fracs().visible >= 0.5) {
                        setTimeout(function() {
                            if ($ad.innerHeight() > 0 && $ad.fracs().visible < 0.5) {
                                fadeAd($ad);
                            }
                        }, 1250);
                    } else {
                        fadeAd($ad);
                    }
                }
                clearInterval(waitingForAd);
            }
            retries--;
        }, conf.waitForAdInterval);

        $(document).bind("stickyNav:on", function(){
            var $ad = $('.sticky-advertisement').eq(0);
            $ad.addClass('sticky-nav-on');
        });

        $(document).bind("stickyNav:off", function(){
            var $ad = $('.sticky-advertisement').eq(0);
            $ad.removeClass('sticky-nav-on');
        });

        return;
    })();

})(window.jQuery);
